import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import "./CustomDialogForEditLogs.css"; // Custom styles for the dialog

const CustomDialogForMasterEditLogs = ({
    isOpen,
    onClose,
    editLogsData,
}) => {
    const [filteredLogs, setFilteredLogs] = useState([]); // Array to hold filtered logs
    const [selectedInvoice, setSelectedInvoice] = useState(""); // Track the currently selected invoice
    const [columnDefs, setColumnDefs] = useState([]); // Column definitions for Ag-Grid

    // Initialize with the first invoice's data
    useEffect(() => {
        if (editLogsData.length > 0) {
    
        // Prepare row data for Ag-Grid
        const rowData = [];
        
        editLogsData.forEach((log) => {
            Object.keys(log?.updating_data || [])
                .filter((key) => !key.endsWith("_modified")) // Exclude keys ending with "_modified"
                .forEach((key) => {
                    rowData.push({
                        field: keyDisplayMap[key] || key,
                        existing_data: log.existing_data[key],
                        updated_data: log.updating_data[key],
                        updated_time: log.modified_date
                            ? formatDate(log.modified_date) // Always format updated_time if not empty
                            : "", // Show empty if no data
                        updated_by: log.updated_by? log.updated_by: ""
                    });
                });
        });
    
        // Update the filtered logs and column definitions for Ag-Grid
        setFilteredLogs(rowData);
        setColumnDefs([
            { headerName: "Field", field: "field", sortable: true, filter: true },
            { headerName: "Existing Data", field: "existing_data", sortable: true, filter: true },
            { headerName: "Updated Data", field: "updated_data", sortable: true, filter: true },
            { headerName: "Updated Time", field: "updated_time", sortable: true, filter: true },
            { headerName: "Updated By", field: "updated_by", sortable: true, filter: true },
        ]);
        }
    }, [editLogsData]);

    // Handle invoice selection
   
    

    // Format date and time
    const formatDate = (dateString) => {
        const date = new Date(dateString); // Parse the UTC date
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const year = date.getUTCFullYear();
        const hours = String(date.getUTCHours()).padStart(2, "0");
        const minutes = String(date.getUTCMinutes()).padStart(2, "0");
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    };

    // Mapping for display names
    const keyDisplayMap = {
        invoice_start_no: "Invoice Start No.",
        invoice_series: "Invoice Series",
        invoice_source: "Invoice Source",
        invoice_category: "Invoice Type",
        entity: "Entity",
        category: "Category",
        transit_time: "Transit Time",
        consignee_name: "Consignee Name",
        consignee_code: "Consignee Code",
        email_id: "Email Id",
        mobile_no: "Mobile No.",
        weight: "Weight",
        tpt_name_1: "Transporter 1",
        tpt_name_2: "Transporter 2"
    };

    // Get unique invoices for the dropdown
    const uniqueInvoices = Array.from(new Set(editLogsData.map((log) => log.invoice_no)));

    // Render dialog only if it's open
    if (!isOpen) return null;

    return (
        <div className="dialog-overlay" onClick={onClose}>
            <div className="dialog-content1" onClick={(e) => e.stopPropagation()}>
                {/* Dialog Header */}
                <div className="dialog-header">
                    <h2>Edit Logs</h2>
                </div>

                {/* Dialog Body */}
                <div className="dialog-body">
                    {/* Dropdown to select invoice */}
                   

                    {/* Display grid with filtered log */}
                    <div
                        className="ag-theme-balham mt-3"
                        style={{ 
                            maxHeight: "400px",width: "100%", overflow: "auto" }}
                    >
                        <AgGridReact
                            columnDefs={columnDefs}
                            rowData={filteredLogs}
                            defaultColDef={{
                                sortable: true,
                                filter: true,
                                resizable: true,
                            }}
                            domLayout="autoHeight"
                            pagination={true}
                            paginationPageSize={50}
                            enableRangeSelection={true}
                            enableCellContextMenu={true}
                        />
                    </div>
                </div>

                {/* Dialog Actions */}
                <div className="dialog-actions">
                    <button className="btn-primary" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomDialogForMasterEditLogs;
